import LoadingTemp from './Loading'
let Loading = {}
let installed
let preventTouch

Loading.install = function(Vue) {
	if (installed) return
	let loadingInstance = null
	Vue.prototype.$Loading = {}
	Vue.prototype.$Loading.show = isGlobal => {
		// 如果页面有loading则不继续执行
		if (loadingInstance) return

		// 2、创建实例，挂载到文档以后的地方
		loadingInstance = new Vue({
			...LoadingTemp,
			propsData: {
				isGlobal,
			},
		}).$mount()
		document.body.appendChild(loadingInstance.$el)

		preventTouch = e => {
			if (e.target.closest('.page-loading-wrap') === loadingInstance.$el) {
				e.stopPropagation()
				e.preventDefault()
			}
		}
		// 阻止遮罩滑动
		document.body.addEventListener('touchmove', preventTouch)
	}
	Vue.prototype.$Loading.hide = () => {
		if (!loadingInstance) return
		document.body.removeEventListener('touchmove', preventTouch)
		document.body.removeChild(loadingInstance.$el)
		loadingInstance = null
	}
	Vue.component('loading', LoadingTemp)
	installed = true
}
export default Loading
